class VideotutorialsController {
  constructor($state,$window,storage,billingService,$timeout,laboxSSapi) {
    this.name = 'Tutorials';
    this.state = $state;
    this.$timeout = $timeout;
    this.videotutorialslandingerror = false;
    this.tutorialarray = [];
    //initializing loader
    this.tutoriallandingLoader = false;
    this.remove_carousel = true;

    //calling api
    if (storage.getItem('session', 'plant_id') && storage.getItem('session', 'plant_id') == 1) {
      laboxSSapi.getOptVideoTutorials().then((res) => {
        console.log('res.data.labox_video_tutorials is ' + res.data.labox_video_tutorials);
        if(res && res.data && !res.data.labox_video_tutorials.length == 0){
          const groups = _.groupBy(res.data.labox_video_tutorials[0].labox_videos, subgroup => subgroup.position_id);

          for (const key in groups) {
            // adding ellipses for longer captions
            if (groups[key][0].title.length > 20)
            {
              this.tutorialarray.push({
                label: groups[key][0].title.substring(0,20)+'...',
                link: groups[key][0].video_image
              });
            } else {
              this.tutorialarray.push({
                label: groups[key][0].title,
                link: groups[key][0].video_image
              });
            }
          }
          console.log("alex result from api/tutorial:", res.data);

          // setting variables for elements
          this.carousell = document.getElementsByClassName("carousel-calculator")[0];
          this.carousell_inner = document.getElementsByClassName("carousel-inner")[0];

          // setting width of carousel
          var carousel_item_width = this.tutorialarray.length * 460;
          this.carousell.style.width = carousel_item_width + "px";

          if (this.tutorialarray.length < 3) {
            console.log('this.tutorialarray.length3 is ' + this.tutorialarray.length);
              //removing loader
            this.tutoriallandingLoader = true;
            this.remove_carousel = false;
          } else if (this.tutorialarray.length == 3){
            console.log('this.tutorialarray.length5 is ' + this.tutorialarray.length);
            //removing loader
            this.tutoriallandingLoader = true;

            // starting carousel
            this.$timeout(() => {

              this.carousell_inner.className += " active3";
            }, 500);

          } else if (this.tutorialarray.length == 4){
            console.log('this.tutorialarray.length5 is ' + this.tutorialarray.length);
            //removing loader
            this.tutoriallandingLoader = true;

            // starting carousel
            this.$timeout(() => {

              this.carousell_inner.className += " active4";
            }, 500);

          } else if (this.tutorialarray.length == 5){
            console.log('this.tutorialarray.length7 is ' + this.tutorialarray.length);
            //removing loader
            this.tutoriallandingLoader = true;

            // starting carousel
            this.$timeout(() => {
              this.remove_carousel = true;
              this.carousell_inner.className += " active5";
            }, 500);
          
          } else if (this.tutorialarray.length == 6){
            console.log('this.tutorialarray.length7 is ' + this.tutorialarray.length);
            //removing loader
            this.tutoriallandingLoader = true;

            // starting carousel
            this.$timeout(() => {
              this.remove_carousel = true;
              this.carousell_inner.className += " active6";
            }, 500);

          } else if (this.tutorialarray.length == 7){
            console.log('this.tutorialarray.length9 is ' + this.tutorialarray.length);
            //removing loader
            this.tutoriallandingLoader = true;

            // starting carousel
            this.$timeout(() => {
              this.remove_carousel = true;
              this.carousell_inner.className += " active7";
            }, 500);

          } else if (this.tutorialarray.length == 8){
            console.log('this.tutorialarray.length9 is ' + this.tutorialarray.length);
            //removing loader
            this.tutoriallandingLoader = true;

            // starting carousel
            this.$timeout(() => {
              this.remove_carousel = true;
              this.carousell_inner.className += " active8";
            }, 500);

          } else {
            console.log('this.tutorialarray.length9 is ' + this.tutorialarray.length);
            this.videotutorialslandingerror = true;
            this.tutoriallandingLoader = true;

          }

        } else {
          this.videotutorialslandingerror = true;
          this.tutoriallandingLoader = true;
        }
      },(reserr)=>{
        this.tutoriallandingLoader = true;
        this.videotutorialslandingerror = true;
      });
    } else if (storage.getItem('session', 'plant_id') && storage.getItem('session', 'plant_id') == 2) {
      laboxSSapi.getSdlVideoTutorials().then((res) => {
        console.log('res.data.labox_video_tutorials is ' + res.data.labox_video_tutorials);
        if(res && res.data && !res.data.labox_video_tutorials.length == 0){
          const groups = _.groupBy(res.data.labox_video_tutorials[0].labox_videos, subgroup => subgroup.position_id);

          for (const key in groups) {
            // adding ellipses for longer captions
            if (groups[key][0].title.length > 20)
            {
              this.tutorialarray.push({
                label: groups[key][0].title.substring(0,20)+'...',
                link: groups[key][0].video_image
              });
            } else {
              this.tutorialarray.push({
                label: groups[key][0].title,
                link: groups[key][0].video_image
              });
            }
          }
          console.log("alex result from api/tutorial:", res.data);

          // setting variables for elements
          this.carousell = document.getElementsByClassName("carousel-calculator")[0];
          this.carousell_inner = document.getElementsByClassName("carousel-inner")[0];

          // setting width of carousel
          var carousel_item_width = this.tutorialarray.length * 460;
          this.carousell.style.width = carousel_item_width + "px";

          if (this.tutorialarray.length < 3) {
            console.log('this.tutorialarray.length3 is ' + this.tutorialarray.length);
              //removing loader
            this.tutoriallandingLoader = true;
            this.remove_carousel = false;
          } else if (this.tutorialarray.length == 3){
            console.log('this.tutorialarray.length5 is ' + this.tutorialarray.length);
            //removing loader
            this.tutoriallandingLoader = true;

            // starting carousel
            this.$timeout(() => {

              this.carousell_inner.className += " active3";
            }, 500);

          } else if (this.tutorialarray.length == 4){
            console.log('this.tutorialarray.length5 is ' + this.tutorialarray.length);
            //removing loader
            this.tutoriallandingLoader = true;

            // starting carousel
            this.$timeout(() => {

              this.carousell_inner.className += " active4";
            }, 500);

          } else if (this.tutorialarray.length == 5){
            console.log('this.tutorialarray.length7 is ' + this.tutorialarray.length);
            //removing loader
            this.tutoriallandingLoader = true;

            // starting carousel
            this.$timeout(() => {
              this.remove_carousel = true;
              this.carousell_inner.className += " active5";
            }, 500);
          
          } else if (this.tutorialarray.length == 6){
            console.log('this.tutorialarray.length7 is ' + this.tutorialarray.length);
            //removing loader
            this.tutoriallandingLoader = true;

            // starting carousel
            this.$timeout(() => {
              this.remove_carousel = true;
              this.carousell_inner.className += " active6";
            }, 500);

          } else if (this.tutorialarray.length == 7){
            console.log('this.tutorialarray.length9 is ' + this.tutorialarray.length);
            //removing loader
            this.tutoriallandingLoader = true;

            // starting carousel
            this.$timeout(() => {
              this.remove_carousel = true;
              this.carousell_inner.className += " active7";
            }, 500);

          } else if (this.tutorialarray.length == 8){
            console.log('this.tutorialarray.length9 is ' + this.tutorialarray.length);
            //removing loader
            this.tutoriallandingLoader = true;

            // starting carousel
            this.$timeout(() => {
              this.remove_carousel = true;
              this.carousell_inner.className += " active8";
            }, 500);

          } else {
            console.log('this.tutorialarray.length9 is ' + this.tutorialarray.length);
            this.videotutorialslandingerror = true;
            this.tutoriallandingLoader = true;

          }

        } else {
          this.videotutorialslandingerror = true;
          this.tutoriallandingLoader = true;
        }
      },(reserr)=>{
        this.tutoriallandingLoader = true;
        this.videotutorialslandingerror = true;
      });
    } else {
      this.videotutorialslandingerror = true;
      this.tutoriallandingLoader = true;
    }
  }
}

VideotutorialsController.$inject = ['$state','$window','storage','billingService','$timeout','laboxSSapi'];

export default VideotutorialsController;



// WEBPACK FOOTER //
// ./client/app/components/videotutorials/videotutorials.controller.js